module.exports = __webpack_public_path__ + "static/img/pc.49a7945.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cn/小学/pc.svg
// module id = +zJU
// module chunks = 16